// index.js or App.jsx
import ReactDOM from "react-dom/client";
import RootRoutes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./css/index.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import ThemeProvider from "./theme/ThemeProvider";
import { applyThemeToDocument, resolveDarkMode } from "./theme/themeUtils";
import { Layout } from "antd";
import GlobalLoader from "./components/loader/GlobalLoader";
import ScrollToTop from "./components/ScrollTop";
import AppInitializer from "./components/AppInitializer";
import MarketingPageViews from "./components/MarketingPageViews";

function App() {
  return (
    <>
      <ScrollToTop />
      <MarketingPageViews />
      <Toaster position="top-right" />
      <GlobalLoader />
      <AppInitializer>
        <RootRoutes />
      </AppInitializer>
    </>
  );
}

const Root = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

applyThemeToDocument(resolveDarkMode());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <Layout className="min-h-screen app-shell">
      <Provider store={store}>
        <Root />
      </Provider>
    </Layout>
  </ThemeProvider>,
);
